import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import "./input.scss";
import { getIn } from "formik";
import { WrapperContainer } from "@corporate-trip-planner-fe/ui-styles";
var RedAsterik = function () {
    return _jsx("span", { style: { color: "red" }, children: "*" });
};
function InputField(_a) {
    var fieldInfo = _a.fieldInfo, formik = _a.formik;
    var fieldName = fieldInfo.name;
    var formikInputValue = getIn(formik.values, fieldName);
    var showError = function () {
        return formik.touched[fieldName] && formik.errors[fieldName] ? true : false;
    };
    var getFirstError = function (error) {
        if (typeof error === "string")
            return error;
        if (Array.isArray(error))
            return getFirstError(error[0]);
        if (typeof error === "object")
            return getFirstError(Object.values(error)[0]);
        return "";
    };
    var getErrorText = function () {
        var error = formik.errors[fieldName];
        var touched = formik.touched[fieldName];
        if (!touched || !error)
            return "";
        return getFirstError(error);
    };
    var handleChange = function (e) {
        var val = fieldInfo.type === "number" ? e.target.valueAsNumber : e.target.value;
        formik.setFieldValue(fieldName, val);
        formik.handleBlur(e);
    };
    return (_jsx(WrapperContainer, { "$padding": "0.5rem", children: _jsx(TextField, __assign({}, fieldInfo, { id: fieldInfo.name, error: showError(), helperText: getErrorText(), 
            /* className={
              showError()
                ? `input-field ${ADDITIONAL_CSS} input-error`
                : `input-field ${ADDITIONAL_CSS}`
            } */
            value: formikInputValue, onChange: handleChange })) }));
}
export default InputField;
